import { useReadContract } from 'wagmi';

import { Worlds, getAssociationBySplit } from 'lib/abis/Worlds';
import { getContractAddress } from 'lib/addresses';
import { ChainId } from 'lib/chains';
import { getAddress } from 'utils/address';

type Options = {
  enabled?: boolean;
};

export function useExhibitionIdBySplit(
  variables: {
    chainId: ChainId;
    contractAddress: string;
    seller: string;
  },
  options: Options = {}
) {
  return useReadContract({
    abi: Worlds,
    address: getContractAddress({
      chainId: variables.chainId,
      contractName: 'worlds',
    }),
    chainId: variables.chainId,
    functionName: 'getAssociationBySplit',
    args: [getAddress(variables.contractAddress), getAddress(variables.seller)],
    query: {
      enabled: options.enabled ?? true,
      select: getAssociationBySplit.parseOutput,
    },
  });
}
